import alt from 'components/Dispatcher';
import {Record} from 'immutable';
import VotingRadioButtonsSearchFieldActions from 'actions/search/VotingRadioButtonsSearchFieldActions';
import immutableStore from 'alt-utils/lib/ImmutableUtil';
import VotingRadioButtonsSearchFieldSource from 'sources/search/VotingRadioButtonsSearchFieldSource';
import {SELECTED_KEYS} from 'components/pure/search/SELECTED_KEYS';

const State = Record({
  teams: [],
  departments: [],
  votingValue: null,
  error: null,
});
export const VotingSearchValue = Record({type: 'some_of', values: null}, 'VotingSearchValue');

@immutableStore
class VotingRadioButtonsSearchFieldStore {
  constructor() {
    this.state = new State();
    this.bindActions(VotingRadioButtonsSearchFieldActions);
    this.registerAsync(VotingRadioButtonsSearchFieldSource);
  }

  onFetchTeams() {
    if (this.state.teams.length === 0) {
      this.getInstance().fetchTeams();
    }
  }

  onFetchTeamsSuccess(resp) {
    const state = this.state.set('teams', resp.data.teams);
    this.setState(state);
  }

  onFetchTeamsError(resp) {
    const state = this.state.set('error', resp);
    this.setState(state);
  }

  onFetchDepartments() {
    if (this.state.departments.length === 0) {
      this.getInstance().fetchDepartments();
    }
  }

  onFetchDepartmentsSuccess(resp) {
    const state = this.state.set('departments', resp.data.departments);
    this.setState(state);
  }

  onFetchDepartmentsError(resp) {
    const state = this.state.set('error', resp);
    this.setState(state);
  }

  onChangeVotingLevel(voting) {
    const partialVotingValue = VotingRadioButtonsSearchFieldStore._partialVotingValueFrom(voting);
    let state = this.state.set('votingValue', partialVotingValue);
    this.setState(state);
  }

  static _partialVotingValueFrom(voting) {
    if (voting.key === SELECTED_KEYS.others_rated_good) {
      return VotingSearchValue({values: ['Up']});
    } else if (voting.key === SELECTED_KEYS.others_rated_bad) {
      return VotingSearchValue({values: ['Down']});
    }
  }

  /**
   * Update the current `votingValue` accordingly
   * @param voting Current voting value/choice selected by the user
   * @type {VotingRadioButtonsSearchFieldValue}
   */
  onChangeVoting(voting) {
    const votingValue = this._votingValueFrom(voting);
    let state = this.state.set('votingValue', votingValue);
    this.setState(state);
  }

  /**
   * Return a voting value from a voting search key
   * @param {VotingRadioButtonsSearchFieldValue} voting voting-related values chosen by the user
   * @private
   */
  _votingValueFrom(voting) {
    if (voting.key === SELECTED_KEYS.i_rated_good) {
      return VotingSearchValue({values: ['user.Up']});
    } else if (voting.key === SELECTED_KEYS.i_rated_bad) {
      return VotingSearchValue({values: ['user.Down']});
    } else {
      if (stringIsValid(voting.value)) {
        const currentVotingValue = this.state.votingValue;
        const values = currentVotingValue.values.map(suffix => {
          // suffix might already be a team/department.id.up/down string, therefore we only need the last segment
          // which can be Up/Down at this point
          let suffixArr = suffix.split('.');
          return voting.value + '.' + suffixArr[suffixArr.length - 1];
        });
        return VotingSearchValue({values: values});
      } else {
        return this._votingValueAfterRemovingSecondLevel();
      }
    }
  }

  static getVotingValue(state) {
    return state.get('votingValue');
  }

  /** Reset this.state.votingValue back to null */
  onResetVoting() {
    let state = this.state.set('votingValue', null);
    this.setState(state);
  }

  onRemoveCurrentVotingValue() {
    let state = this.state.set('votingValue', this._votingValueAfterRemovingSecondLevel());
    this.setState(state);
  }

  _votingValueAfterRemovingSecondLevel() {
    const currentVotingValue = this.state.votingValue;
    const values = currentVotingValue.values.map(value => {
      const valueSegments = value.split('.');
      return valueSegments[valueSegments.length - 1];
    });
    return VotingSearchValue({values: values});
  }
}

export default alt.createStore(
  VotingRadioButtonsSearchFieldStore,
  'VotingRadioButtonsSearchFieldStore'
);

function stringIsValid(value) {
  return value && value.length > 0;
}
